import React from 'react';
import { useNotify } from 'react-admin';
import { Grid } from '@material-ui/core';
import { useSelector } from 'react-redux';
import { Complete } from '@/components/Order';
import { Load, Filter } from '@/components/Global';
import { getOrder, AccRequest, SaveData, SaveApiResMessage } from '@/actions';
import { ParseOrderComplete } from '@/actions/ParseData';
import styles from './styles';
import LoadingV2 from '@/components/Loading';

const perPage = 8;

export default (props) => {
  const cls = styles();
  const notify = useNotify();
  const [loading, setLoading] = React.useState(true);
  const [DATA, setData] = React.useState([]);
  const [filter, setFilter] = React.useState({
    open: false,
    DATA: [],
  });

  const [page, setPage] = React.useState(1);
  const disableLoad = () => {
    if (page * perPage < DATA.length) return false;
    else return true;
  };
  const RefreshPage = useSelector((state) => state.reducer.refreshPage || '');
  const RefreshData = React.useCallback(() => {
    setLoading(true);
    getOrder('complete')
      .then((res) => {
        let DATA = ParseOrderComplete(res);
        setData(DATA);
        setFilter({ open: false, DATA });
        setLoading(false);
      })
      .catch((err) => {
        // notify(err, 'warning');
        SaveApiResMessage({
          title: 'Error',
          message: err,
          mode: 'warning',
        });
        setLoading(false);
      });
  }, [notify]);

  React.useEffect(() => {
    if (RefreshPage === 'order') {
      RefreshData();
      SaveData({ refreshPage: '' });
    }
  }, [RefreshPage, RefreshData]);

  React.useEffect(() => {
    RefreshData();
  }, [RefreshData]);

  const Accept = (item) => {
    AccRequest({
      id: item.id,
      count: item.num,
    })
      .then((res) => {
        // notify(res);
        SaveApiResMessage({
          title: res?.data?.messageHeader,
          message: res,
          mode: 'success',
        });
      })
      .catch((err) => {
        // notify(err, 'warning');
        SaveApiResMessage({
          title: 'Error',
          message: err,
          mode: 'warning',
        });
      });
  };

  const getData = React.useCallback(
    () => filter.DATA.slice(0, page * perPage),
    [filter.DATA, page]
  );

  return (
    <div className={cls.content}>
      <Filter
        title="My Offers/Completed"
        filter={filter}
        setFilter={setFilter}
        DATA={DATA}
      />

      <div className={cls.list}>
        {loading ? (
          <div className="mt-16">
            <LoadingV2 />
          </div>
        ) : (
          <Grid container spacing={2}>
            {getData().map((i, idx) => (
              <Grid item xs={12} sm={6} lg={3} xl="auto" key={idx}>
                <Complete RefreshData={RefreshData} DATA={i} Accept={Accept} />
              </Grid>
            ))}
          </Grid>
        )}
      </div>
      <Load onLoad={() => setPage(page + 1)} disable={disableLoad()} />
    </div>
  );
};
